import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import * as ChronoUnit from 'automation-ui-flow-core/fields/time/ChronoUnit';
export default class TimeDelta extends createImmutableObjectClass({
  delta: 0,
  timeUnit: ChronoUnit.DAYS
}) {
  getDelta() {
    return this.delta;
  }
  setDelta(delta) {
    return this.set('delta', delta);
  }
  getTimeUnit() {
    return this.timeUnit;
  }
  setTimeUnit(timeUnit) {
    return this.set('timeUnit', timeUnit);
  }
}